import { Workouts } from "app-interfaces";

import { Brand } from "./utils";

export type UserGender = "MALE" | "FEMALE";

export type UserRole = "ROLE_ADMIN" | "ROLE_TRAINER" | "ROLE_CUSTOMER" | "ROLE_MANAGER";

export enum UserStatus {
  NOT_REGISTERED = "NOT_REGISTERED",
  REGISTRATION_INCOMPLETE = "REGISTRATION_INCOMPLETE",
  REGISTERED = "REGISTERED",
  INVITED = "INVITED",
  NONE = "NONE",
}

export type SubcriptionPlans = "PERSONAL" | "COMPANY" | "FREE";

export enum SubscriptionPlanInterval {
  month = "MONTH",
  year = "YEAR",
}

export type SubscriptionStatus =
  | "INACTIVE"
  | "TRIAL"
  | "TRIAL_EXPIRED"
  | "ACTIVE"
  | "FAILED"
  | "UNSUBSCRIBED";

// synced with  PETE\BackendBundle\Entity$types
export enum EventType {
  Availability = "AVAILABILITY",
  AvailabilityPatch = "AVAILABILITY_PATCH",
  BlockedDays = "BLOCKED_DAYS",
  BlockedTime = "BLOCKED_TIME",
  Lunch = "LUNCH",
  LunchPatch = "LUNCH_PATCH",
  Session = "SESSION",
  Break = "SESSION_INTERVAL",
}

export enum DayTypes {
  "MON" = 1,
  "TUE",
  "WED",
  "THU",
  "FRI",
  "SAT",
  "SUN" = 0,
}

export enum MonthTypes {
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
}

export const enum ExerciseType {
  WEIGHT = "WEIGHT",
  CARDIO = "CARDIO",
  CORE = "CORE",
  MOBILITY = "MOBILITY",
  STRENGTH = "STRENGTH",
  YOGA = "YOGA",
}

/** @deprecated in favor of using the const string enum */
export enum ExerciseTypesEnum {
  "WEIGHT", //0
  "CARDIO", //1
  "CORE", //2
  "MOBILITY", //3
  "STRENGTH", //4
  "YOGA", //5
}

export enum ExerciseFocus {
  "ABS",
  "BACK",
  "BICEPS",
  "CHEST",
  "FOREARMS",
  "FULLBODY",
  "GLUTES",
  "LEGS",
  "SHOULDERS",
  "TRICEPS",
}

export enum ExerciseEquipment {
  "ARM_SLINGERS",
  "BAND",
  "BARBELL",
  "BELT_SQUAT",
  "BENCH",
  "BIKE",
  "BODY_WEIGHT",
  "BOSU_BALL",
  "CABLE",
  "DUMBBELL",
  "ELLIPTICAL",
  "EZ_BARBELL",
  "HAMMER",
  "JUMP_ROPE",
  "KETTLEBELL",
  "LEVERAGE_MACHINE",
  "MEDICINE_BALL",
  "PARALLEL_BARS",
  "POWER_SLED",
  "PUSH_UP_HANDLES",
  "RESISTANCE_BAND",
  "RINGS",
  "ROLLER",
  "ROPE",
  "ROW_MACHINE",
  "SKI_ERG",
  "SLED_MACHINE",
  "SMITH_MACHINE",
  "STABILITY_BALL",
  "STAIR_STEPPER",
  "STATIONARY_BIKE",
  "SUSPENSION",
  "TIRE",
  "TRAP_BAR",
  "TREADMILL",
  "VERSA_CLIMBER",
  "WEIGHT",
  "OTHER",
  "NO_EQUIPMENT",
}

export enum ScoreType {
  "TIME",
  "REPS",
  "LENGTH",
  "PAUSE",
  "KG_WEIGHTS",
  "INCLINE",
  "SPEED",
  "PULSE",
  "PULSE_ZONE",
  "RPE/BORG",
  "WATT",
}

export type ScoreTypeName = keyof typeof ScoreType;

export enum WorkoutScoreType {
  "TIME",
  "REPS",
}

export enum CardioScoreType {
  "TIME",
  "LENGTH",
}

export enum WorkoutScoreColumns {
  "PAUSE",
}

export enum StrengthScoreColumns {
  "KG_WEIGHTS",
}

export enum CardioScoreCloumns {
  "INCLINE",
  "SPEED",
  "PULSE",
  "PULSE_ZONE",
  "RPE/BORG",
  "WATT",
}

export type SessionState = "NONE" | "COMPLETED" | "CANCELLED";

export enum SessionTypes {
  "LUNCH",
  "ADDNEW",
  "BREAK",
  "OPTIONS",
  "NORMAL",
  "BLOCKED_TIME",
}

export type SessionType = "LUNCH" | "ADDNEW" | "BREAK" | "OPTIONS" | "NORMAL" | "BLOCKED_TIME";

export enum SessionForms {
  "WORKOUTS",
  "SESSIONDETAILS",
}

export type TemplateProps = {
  workout: Workouts.IWorkout;
};

// TODO: find out what this is supposed to describe. Is this purely client side information?
export type EventProps = {
  title: string;
  start: string;
  end: string;
  allDay: boolean;
  resource: {
    available: boolean;
    full: boolean;
    timezone: string;
    created: string;
  };
};

export type Action = {
  type: string;
  payload?: any;
  callback?: () => void;
};

export type UUID = Brand<string, "UUID">;
